import React, {useEffect, useRef, useState} from 'react';
import './HeaderBar.scss';
import { useLocationRoute } from '../data/locationRoutes';
import { mapUrl } from './LocationInfo';

import bgProducts from '../assets/bgproducts.png';

import napaAutoCare from '../assets/napa-autocare-horizontal.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBars,
    faTimes,
    faPhone,
    faMapMarkerAlt,
    faHome,
    faClipboardCheck,
    faTools, faTruckPickup, faDotCircle
} from '@fortawesome/free-solid-svg-icons';

import {NavLink, useLocation} from "react-router-dom";


const isIOS = () => {
    return (
        (typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)) ||
        (typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
};

const HeaderBar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const { shop, page, to } = useLocationRoute();
    const [appleMaps, setAppleMaps] = useState(false);
    useEffect(() => { setAppleMaps(isIOS()); }, []);
    const menuRef = useRef();
    const menuButtonRef = useRef(); // Ref for the menu button


    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);





    const handleOutsideClick = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target) && !menuButtonRef.current.contains(e.target)) {
            setIsMenuOpen(false);
        }
    };

    useEffect(() => {
        const eventType = 'ontouchstart' in window ? 'touchstart' : 'mousedown';

        if (isMenuOpen) {
            document.addEventListener(eventType, handleOutsideClick);
        } else {
            document.removeEventListener(eventType, handleOutsideClick);
        }

        return () => {
            document.removeEventListener(eventType, handleOutsideClick);
        };
    }, [isMenuOpen]);


    const iosMapLink = "https://maps.apple.com/?address=588%20E%20Side%20Hwy,%20Waynesboro,%20VA%20%2022980,%20United%20States&auid=10316907240851707088&ll=38.111308,-78.857367&lsp=9902&q=Goldwrench%20Automotive&t=m";
    const googleMapLink = "https://www.google.com/maps/place/GOLDWrench+Automotive/@38.1113436,-78.8598249,17z/data=!3m1!4b1!4m6!3m5!1s0x89b362bcc95c2aa9:0x67bf92da47382ca!8m2!3d38.1113394!4d-78.85725!16s%2Fg%2F1vgw9hqh?entry=ttu";
    const ServiceButtons = page === '/' ? (
        <div className="service-buttons">
            <NavLink  to={to('/stateinspection')}  className={({ isActive }) => isActive ? 'active' : undefined}>
                <span className="service-btn">  <FontAwesomeIcon icon = {faClipboardCheck}></FontAwesomeIcon> STATE INSPECTION</span>
            </NavLink>
            <NavLink  to={to('/autorepairs')}  className={({ isActive }) => isActive ? 'active' : undefined}>
                <span className="service-btn"><FontAwesomeIcon icon = {faTools}></FontAwesomeIcon> AUTO REPAIR</span>
</NavLink>
                <NavLink  to={to('/towingservice')}  className={({ isActive }) => isActive ? 'active' : undefined}>
                    <span className="service-btn"><FontAwesomeIcon icon = {faTruckPickup}></FontAwesomeIcon> TOWING</span>
                </NavLink>
                <NavLink  to={to('/tires')}  className={({ isActive }) => isActive ? 'active' : undefined}>
                    <span className="service-btn"><FontAwesomeIcon icon = {faDotCircle}></FontAwesomeIcon> TIRES</span>
                </NavLink>


        </div>
) : null;


    useEffect(() => {
        if (!isMenuOpen) return undefined;
        const closeOnEscape = (event) => {
            if (event.key === 'Escape') {
                setIsMenuOpen(false);
                menuButtonRef.current?.focus();
            }
        };
        document.addEventListener('keydown', closeOnEscape);
        return () => document.removeEventListener('keydown', closeOnEscape);
    }, [isMenuOpen]);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <div className={`header-container${page === '/' ? "" : " header-container--interior"}`}>
            <header className="HeaderBar">
                <button className="menu-icon" onClick={toggleMenu} ref={menuButtonRef} aria-expanded={isMenuOpen} aria-controls="primary-navigation" aria-label={isMenuOpen ? "Close menu" : "Open menu"}>
                    <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} size="2x"/>
                    <span   className="visually-hidden">Tabs</span>
                </button>
                <nav id="primary-navigation" aria-label="Main navigation" className={isMenuOpen ? "active" : ""} ref={menuRef}>
                    <ul>
                        <li>
                            <NavLink to={to('/')} end className={({isActive}) => isActive ? 'active' : undefined}>
                                <span className="home-nav-icon" aria-hidden="true"><FontAwesomeIcon icon={faHome}/></span><span className="home-nav-text">HOME</span>
                            </NavLink>
                        </li>

                        <li><NavLink to={to('/autorepairs')} className={({isActive}) => isActive ? 'active' : undefined}>AUTO
                            REPAIRS</NavLink></li>
                        <li><NavLink to={to('/towingservice')}
                                     className={({isActive}) => isActive ? 'active' : undefined}>TOWING</NavLink></li>
                        <li><NavLink to={to('/tires')}
                                     className={({isActive}) => isActive ? 'active' : undefined}>TIRES</NavLink></li>
                        <li><NavLink to={to('/stateinspection')} className={({isActive}) => isActive ? 'active' : undefined}>STATE
                            INSPECTION</NavLink></li>
                        <li><NavLink to={to('/about')}
                                     className={({isActive}) => isActive ? 'active' : undefined}>ABOUT</NavLink></li>
                        <li><NavLink to={to('/contact')}
                                     className={({isActive}) => isActive ? 'active' : undefined}>CONTACT</NavLink></li>
                    </ul>
                </nav>

                <div className="right-icons" style={{
                    float: 'right'
                }}>
                    <div className="contact-icons" style={{paddingRight: "20px"}}>
                        <a href={shop ? `tel:${shop.phone}` : "/contact"} aria-label={shop ? `Call ${shop.city}` : "Choose a shop to call"}>
                        <FontAwesomeIcon icon={faPhone} size="2x" color="green"/>
                            <span className="icon-label" style={{paddingRight: "20px"}}>{shop ? `Call ${shop.city}` : "Call a shop"}</span>
                        </a>
                        <a href={shop ? (shop.id === "waynesboro" ? (appleMaps ? iosMapLink : googleMapLink) : mapUrl(shop, appleMaps)) : "/contact"} aria-label={shop ? `Directions to ${shop.city}` : "Choose a shop for directions"}>
                            <FontAwesomeIcon icon={faMapMarkerAlt} size="2x" color="red"/>
                            <span className="icon-label">{shop ? "Directions" : "Find a shop"}</span>
                        </a>
                    </div>


                </div>

            </header>
            <div className="branding">
                <div className="HeaderBar-logo">
                    <NavLink to={to('/')} end className={({isActive}) => isActive ? 'active' : undefined}> <img
                        src="/images/GoldWrench_logo.webp" width="330" height="231" alt="GOLDWrench Automotive"/></NavLink>
                </div>
                <div className="partner-logos">
                    <NavLink to={to('/bgproducts')} className={({isActive}) => isActive ? 'active' : undefined}> <img
                        src={bgProducts} width="131" height="69" alt="BG Products"/></NavLink>
                    <NavLink to={to('/napa')} className={({isActive}) => isActive ? 'active' : undefined}><img
                        src={napaAutoCare} width="189" height="69" alt="NAPA AutoCare"/></NavLink>
                </div>

            </div>
            {ServiceButtons}
        </div>
    );
};

export default HeaderBar;
